import React from "react";
import { Button } from "@chakra-ui/react";
import "../styles/splash.css";

type SplashScreenProps = {
  onTakeTour: () => void;
  onTalkToLexi: () => void;
};

function LexiLogo() {
  return (
    <svg
      viewBox="0 0 600 400"
      role="img"
      aria-label="Lexi logo"
      preserveAspectRatio="xMidYMid meet"
    >
      <g
        transform="translate(0,400) scale(0.05,-0.05)"
        fill="currentColor"
        stroke="none"
      >
        <path d="M4673 6352 c-450 -189 -871 -764 -1064 -1449 l-34 -123 -213 0 c-428 0 -673 121 -805 396 l-63 131 -37 -45 c-54 -67 -47 -187 16 -304 118 -216 362 -321 822 -353 l220 -15 -57 -190 c-142 -479 -264 -783 -307 -771 -611 173 -1231 -97 -1231 -535 0 -479 857 -470 1371 15 166 157 133 154 334 28 1089 -683 1724 -909 2445 -871 442 24 859 215 951 436 36 88 -1 120 -76 65 -192 -142 -401 -195 -775 -194 -563 0 -914 105 -1804 539 -240 116 -508 244 -596 282 -88 39 -163 74 -167 77 -4 4 39 113 94 243 56 130 156 398 222 596 66 198 131 367 145 375 14 8 88 37 163 65 462 169 907 599 1021 989 138 469 -160 788 -575 613z m365 -140 c194 -206 -32 -751 -450 -1088 -120 -96 -484 -295 -504 -275 -31 32 262 820 379 1017 197 334 446 484 575 346z m-2062 -2763 c126 -37 125 -35 18 -193 -249 -363 -747 -486 -840 -207 -98 294 386 530 822 400z" />
        <path d="M8460 5255 c-307 -163 -115 -563 206 -428 90 38 191 148 206 225 36 194 -204 312 -412 203z" />
        <path d="M5385 4701 c-583 -139 -1057 -1015 -765 -1417 365 -505 1195 -248 1680 520 134 212 118 213 186 -5 l56 -180 -41 -58 c-93 -131 -321 -316 -456 -372 -167 -69 -178 -79 -144 -120 73 -88 325 20 552 237 l163 155 59 -105 c257 -455 695 -415 1085 98 l94 125 13 -120 c54 -516 576 -577 1030 -121 225 225 360 528 254 569 -35 13 -30 20 -134 -189 -245 -489 -737 -659 -737 -254 0 108 59 345 170 681 150 455 148 466 -81 489 -162 17 -213 -47 -356 -448 -107 -300 -245 -535 -423 -718 -280 -290 -480 -227 -620 193 l-53 158 224 251 c241 271 402 402 517 421 125 21 142 30 142 76 0 126 -138 183 -283 117 -105 -48 -212 -152 -417 -404 -249 -306 -227 -304 -291 -26 -80 348 -121 406 -284 406 -206 0 -261 -80 -206 -298 61 -237 47 -275 -232 -635 -443 -572 -1017 -665 -1061 -171 -13 139 -23 131 199 153 408 41 817 465 737 765 -52 193 -303 291 -577 227z m310 -185 c125 -104 -126 -525 -380 -635 -240 -104 -279 -82 -213 121 127 391 427 651 593 514z" />
      </g>
    </svg>
  );
}

export default function SplashScreen({ onTakeTour, onTalkToLexi }: SplashScreenProps) {
  return (
    <div className="splash-root">
      <picture className="splash-bg">
        <source srcSet="/assets/lexi/lexi_splash.webp" type="image/webp" />
        <img src="/assets/lexi/lexi_splash.png" alt="" loading="eager" />
      </picture>
      <div className="splash-overlay" aria-hidden="true" />
      <div className="splash-content">
        <div className="splash-logo">
          <LexiLogo />
        </div>
        <p className="splash-tagline">Your Personal AI Companion</p>
        <div className="splash-actions">
          <Button
            className="splash-button splash-primary"
            variant="unstyled"
            type="button"
            onClick={onTakeTour}
          >
            Take a Tour
          </Button>
          <Button
            className="splash-button splash-secondary"
            variant="unstyled"
            type="button"
            onClick={onTalkToLexi}
          >
            Talk to Lexi
          </Button>
        </div>
      </div>
    </div>
  );
}
